import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { UserService } from '../shared/user/user-service.service';
import { HttpErrorResponse } from '@angular/common/http';
// import { User } from '../models/user';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  model: any = {};
  isLoginError = false;
  returnUrl: string;
  isLoginError2 = false;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService
    // private alertService: AlertService
  ) {
    // console.log('login constructor');

   }

  ngOnInit() {
    // console.log('login component init');
    this.userService.logout();

  // get return url from route parameters or default to '/'
  //// this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

  }

  login() {
//    console.log('call login');
    // this.loading = true;
    // console.log(this.route);
    this.isLoginError2 = true;
    this.userService.login(this.model.username, this.model.password)
        .subscribe(
          (data: any) => {
//              console.log('data arrive:'+data);
//              console.log(this.route);
              // this.router.navigate([this.returnUrl]);
              this.isLoginError2 = false;
              localStorage.setItem('appToken', data.access_token);
              localStorage.setItem('loggedUserId' , data.id);
              this.router.navigate(['/calc']);
            },
            (err: HttpErrorResponse) => {
              this.isLoginError = true;
            }
            // error => {
              // console.log('Error:'+error.message);
              // console.log(error);
              // this.alertService.error(error);
              //  this.loading = false;
            // }
            );
  }

}
